import { MarkType } from './MarkType';
/**
 * Mark layer option describing the data transform applied to the mark.
 */
export var MarkTransform;
(function (MarkTransform) {
    MarkTransform["Stack"] = "stack";
    MarkTransform["Group"] = "group";
    MarkTransform["Identity"] = "identity";
    MarkTransform["Stack100Percent"] = "stack100percent";
})(MarkTransform || (MarkTransform = {}));
/**
 * Mark layer option describing how lines should interpolate between points.
 */
export var MarkInterpolation;
(function (MarkInterpolation) {
    MarkInterpolation["Linear"] = "linear";
    MarkInterpolation["Spline"] = "catmullRom";
    MarkInterpolation["Step"] = "step";
    MarkInterpolation["StepAfter"] = "stepAfter";
    MarkInterpolation["StepBefore"] = "stepBefore";
})(MarkInterpolation || (MarkInterpolation = {}));
/**
 * Mark layer option describing how to handle null values.
 */
export var MarkNullTreatment;
(function (MarkNullTreatment) {
    MarkNullTreatment["Break"] = "break";
    MarkNullTreatment["ConnectDashed"] = "connectDashed";
    MarkNullTreatment["TreatAsZero"] = "treatAsZero";
})(MarkNullTreatment || (MarkNullTreatment = {}));
